export enum InfoCardType {
  ACCORDION,
  LINK,
  BADGE,
}
